import { Action, Reducer } from "redux";
import { AssessmentTypeState, AssessmentTypeTypes, AssessmentTypeActionTypes } from "./assessmentTypeTypes";

export const INITIAL_STATE: AssessmentTypeState = {
	assessmentType: {
		data: null,
		errorMessages: null,
		isError: false,
		isLoading: false,
	},
};

const assessmentTypeReducer: Reducer<AssessmentTypeState> = (
	state: AssessmentTypeState = INITIAL_STATE,
	action: Action,
) => {
	const actionTypes = action as AssessmentTypeActionTypes;
	switch (actionTypes.type) {
		case AssessmentTypeTypes.GET_ASSESSMENT_TYPE:
			return {
				...state,
				assessmentType: { ...state.assessmentType, isLoading: true },
			};
		case AssessmentTypeTypes.SAVE_ASSESSMENT_TYPE:
			return {
				...state,
				assessmentType: {
					...state.assessmentType,
					isLoading: false,
					errorMessages: actionTypes.payload.errorMessages,
					isError: actionTypes.payload.isError,
					data: actionTypes.payload.data,
				},
			};
		case AssessmentTypeTypes.RESET_REDUCER_ASSESSMENT_TYPE:
			return {
				...state,
				assessmentType: INITIAL_STATE.assessmentType,
			};
		default:
			return state;
	}
};

export default assessmentTypeReducer;
